/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";

import { getData, postData, putData, uploadSingleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { reactSelectStyle } from "Config/Config";
import { getMemberOptions } from "helper/ContactHelper/ContactHelper";
import { fetchOptions } from "helper/Common/CommonHelper";

const SaveConditionPopup = ({
  selectedConditionId,
  setSelectedConditionId,
  afterActionClose,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
  };

  const [statusOptions, setStatusOptions] = useState([]);
  const [medicalCondition, setMedicalCondition] = useState(null);
  const [status, setStatus] = useState(null);
  const [reportedDate, setReportedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [resolvedOn, setResolvedOn] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [comments, setComments] = useState("");
  const [assignTo, setAssignTo] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  // Async load options for assignee
  const loadAssineeOptions = async (inputValue) => {
    try {
      const options = await getMemberOptions(inputValue);
      return options;
    } catch (error) {
      return [];
    }
  };

  // Async load options for medical condition
  const loadMedicalConditionOptions = async (inputValue) => {
    if (!inputValue || inputValue.length <= 1) {
      return [];
    }
    try {
      let requestUrl = url.SERVER_URL + url.MEDICAL_CONDITIONS_OPTIONS;
      const response = await getData(requestUrl);
      return response.filter((item) =>
        item.name.toLowerCase().includes(inputValue.toLowerCase())
      );
    } catch (error) {
      return [];
    }
  };

  // Get condition details for edit
  const getConditionDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MEDICAL_CONDITION_BY_ID +
        `/${selectedConditionId}?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status) {
        const conditionData = response.data;
        setMedicalCondition(conditionData?.conditionvalue);
        setStatus({
          value: conditionData.currentstatus,
          label: conditionData.currentstatus,
        });
        setReportedDate(
          conditionData.reportedon
            ? new Date(conditionData.reportedon).toISOString().split("T")[0]
            : ""
        );
        setResolvedOn(
          conditionData.resolvedon
            ? new Date(conditionData.resolvedon).toISOString().split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        setComments(conditionData.comments);
        if (conditionData.assignedtovalue) {
          setAssignTo({
            value: conditionData.assignedtovalue,
            label: conditionData.assignedtolabel,
          });
        }
      }
    } catch (error) {}
  };

  // Save handler
  const saveConditionHandler = async () => {
    try {
      setIsSaving(true);
      const reportedonFormnated =
        reportedDate !== "" ? new Date(reportedDate).toISOString() : "";
      const resolvedonFormatted =
        resolvedOn !== "" ? new Date(resolvedOn).toISOString() : "";
      const apiData = {
        condition: medicalCondition?.value,
        conditionname: medicalCondition?.name,
        currentstatus: status?.value,
        reportedon: reportedonFormnated,
        resolvedon: selectedConditionId ? resolvedonFormatted : "",
        comments: comments,
        assignto: assignTo ? assignTo.value : null,
      };
      let requestUrl = url.API_BASE_URL;
      let response = {};
      if (selectedConditionId) {
        requestUrl +=
          url.API_UPDATE_MEDICAL_CONDITION +
          `/${selectedConditionId}?token=${token}`;
        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_MEDICAL_CONDITION + `?token=${token}`;
        response = await postData(requestUrl, apiData);
      }
      setIsSaving(false);
      if (response.status) {
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveConditionOffCanvas")
        ).hide();
        resetHandler();
        afterActionClose([response.data]);
      }
    } catch (error) {}
  };

  const resetHandler = () => {
    setMedicalCondition(null);
    setStatus(null);
    setReportedDate(new Date().toISOString().split("T")[0]);
    setResolvedOn(new Date().toISOString().split("T")[0]);
    setComments("");
    setAssignTo(null);
    setSelectedConditionId(null);
  };

  useEffect(() => {
    if (selectedConditionId) {
      getConditionDetails();
    }
  }, [selectedConditionId]);

  useEffect(() => {
    fetchOptions(
      `${url.SERVER_URL}${url.CONDITION_STATUS_OPTIONS}`,
      setStatusOptions
    );
  }, []);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveConditionOffCanvas"
      aria-labelledby="saveConditionOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              description
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Save Condition
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update condition details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column"
          >
            <div className="fields-container flex-fill">
              {/* Medical Condition */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                  Name of the Condition <span className="text-danger">*</span>
                </label>
                <AsyncSelect
                  isClearable
                  name="conditionType"
                  loadOptions={loadMedicalConditionOptions}
                  defaultOptions={false}
                  cacheOptions={false}
                  placeholder="Search for Condition"
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  value={medicalCondition}
                  onChange={setMedicalCondition}
                />
              </div>

              {/* Info block for selected condition */}
              {medicalCondition && (
                <>
                  <div className="mb-4 p-3 border rounded-10 bg-light">
                    <div className="mb-2">
                      <div className="fw-bold text-primary d-flex align-items-center gap-2">
                        <sapn>{medicalCondition?.name}</sapn>
                        <span className="material-symbols-outlined me-2 text-success">
                          health_and_safety
                        </span>
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "0.95em" }}
                      >
                        {medicalCondition?.description}
                      </div>
                    </div>
                    <hr />
                    <div>
                      <span className="fw-bold text-primary">Symptoms</span>
                      <ul className="mb-2" style={{ color: "#666" }}>
                        {medicalCondition?.symptoms?.map((symptom, index) => (
                          <li key={index}>{symptom}</li>
                        ))}
                      </ul>
                    </div>
                    <hr />
                    <div>
                      <span className="fw-bold text-primary">Treatment</span>
                      <div
                        className="text-muted"
                        style={{ fontSize: "0.95em" }}
                      >
                        {medicalCondition?.treatment}
                      </div>
                    </div>
                  </div>

                  {/* Status */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Status <span className="text-danger">*</span>
                    </label>
                    <Select
                      isClearable
                      name="status"
                      options={statusOptions}
                      placeholder="Select Status"
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      value={status}
                      onChange={setStatus}
                    />
                  </div>

                  {/* Reported On */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Reported On <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      name="firstOccurrence"
                      value={reportedDate || ""}
                      onChange={(e) => setReportedDate(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                    />
                  </div>

                  {/* Resolved On (only if editing) */}
                  {selectedConditionId && (
                    <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                      <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                        Resolved On
                      </label>
                      <input
                        type="date"
                        name="resolvedOn"
                        value={resolvedOn || ""}
                        onChange={(e) => setResolvedOn(e.target.value)}
                        className="form-control fs-sm shadow-none border border-gray-300"
                      />
                    </div>
                  )}

                  {/* Comments */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="comments"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Comments
                    </label>
                    <textarea
                      name="comments"
                      id="comments"
                      rows="5"
                      placeholder="Enter Comments"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                    ></textarea>
                  </div>

                  {/* Assign To */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Assign To
                    </label>
                    <AsyncSelect
                      isClearable
                      name="assignTo"
                      loadOptions={loadAssineeOptions}
                      defaultOptions={false}
                      cacheOptions={false}
                      placeholder="Select Assignee"
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      value={assignTo}
                      onChange={setAssignTo}
                    />
                  </div>
                </>
              )}
            </div>
            {/* Save button only if status and reportedDate are filled */}
            {medicalCondition && status && reportedDate !== "" && (
              <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  disabled={isSaving}
                  style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                  onClick={saveConditionHandler}
                >
                  {isSaving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <span className="material-symbols-outlined me-1">
                        save
                      </span>
                      Save Condition
                    </>
                  )}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveConditionPopup;
